import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'

import { environment } from '../../environments/environment'
import {
  VerificationOfficeLookupResult,
  VerificationOfficeOverview
} from '../_models/verification-office.interface'

// Eichamt-Stammdaten und PLZ-Zuordnung (siehe bentomax/hawk#574).
// Das Instandsetzerkennzeichen liegt am Techniker und laeuft ueber die
// Benutzerverwaltung, nicht ueber diesen Service.
@Injectable({
  providedIn: 'root'
})
export class VerificationOfficeService {

  private basePath = environment.apiURL

  constructor(private http: HttpClient) {
  }

  // Hinterlegte Eichämter samt Abdeckung nach Bundesland
  public getOverview(): Observable<VerificationOfficeOverview> {
    return this.http.get<VerificationOfficeOverview>(`${this.basePath}verification_offices`)
  }

  // Zuständiges Eichamt zu einer PLZ nachschlagen. Der Endpunkt liefert auch
  // die negativen Fälle mit Begründung — nicht als Fehler behandeln.
  //
  // Der Ort ist optional und wird nur für die zehn PLZ gebraucht, die auf einer
  // Landesgrenze liegen und zwei zuständige Ämter haben.
  public lookup(postalCode: string, city?: string): Observable<VerificationOfficeLookupResult> {
    let params = new HttpParams().set('postal_code', postalCode)
    if (city?.trim()) {
      params = params.set('city', city.trim())
    }

    return this.http.get<VerificationOfficeLookupResult>(
      `${this.basePath}verification_offices/lookup`, { params }
    )
  }
}
